var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("雷达图")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("attrs 包含若干属性，可以初始化图表的时候对图表进行配置")
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("gridType")]),
            _vm._v(" "),
            _c("td", [_vm._v("网格的类型，可选值为'polygon'和'circle'")]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_vm._v("polygon")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("splitNumber")]),
            _vm._v(" "),
            _c("td", [_vm._v("背景网格的层数")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("4")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("startAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴的起始角度")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("270")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("radius")]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图的轴长,范围[0,1]")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0.6")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("labelOffset")]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图轴标记偏移量")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("6")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("可配置 Style 名称")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-js" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" radar = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Radar()\nradar.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("size")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v(" })\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 或者函数模式")
            ]),
            _vm._v("\nradar.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point'")
            ]),
            _vm._v(",(attr,data,i)=>{"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" {"),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("size")
            ]),
            _vm._v(":"),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v("}})\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "style 方式支持链式调用，第一个参数为 style 名称，第二个参数为设置的样式 Object，也可以为函数形式，对样式进行详细设置"
        )
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("section")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图数据区样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("section:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图数据区 hover 样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("面，除了基础面的全部属性外，还有("),
              _c(
                "a",
                {
                  staticStyle: { "text-decoration": "underline" },
                  attrs: { href: "./#/doc/plugin/Point" }
                },
                [_vm._v("Point")]
              ),
              _vm._v(")的特殊属性")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图数据区域的点的样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("axis")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴的样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("grid")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("雷达图背景网格样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("label")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("类别指示文字的样式(x 轴)")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("scale")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("数值指示文字,(y 轴)")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }